import { action, observable, computed } from 'mobx';
import AddressFormStore from '../../domain/entities/AddressFormStore/index';

export default class AUPostCollectionsRepository {
  @observable widgetInitialized: boolean;

  @observable public readonly formStore: AddressFormStore;

  @observable isFormReady = false;

  constructor() {
    this.widgetInitialized = false;
  }

  @action
  setWidgetInitilized = (initilized: boolean): void => {
    this.widgetInitialized = initilized;
  };

  @computed
  get isFormValid(): boolean {
    return this.isFormReady;
  }
}
